// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tournament_quest_container__UvhA7 {
  width: 80%;
  margin: 0 auto;
  position: relative;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 {
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s linear;
  height: auto;
  max-width: 368px;
  width: 100%;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_img__6jeho {
  object-fit: cover;
  width: 100%;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_name__ziHcj {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_name__ziHcj .Tournament_quest_inner_name_up__e5kZN {
  color: #ae6fff;
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_name__ziHcj .Tournament_quest_inner_name_status__eb7Dl {
  border-radius: 8px;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
  padding: 12px;
  background-color: rgba(241, 248, 19, 0.15);
  color: #f1f813;
  min-width: 82px;
  display: flex;
  justify-content: center;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_desc_block__\\+W\\+Q2 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_desc_block__\\+W\\+Q2 .Tournament_quest_inner_desc_block_name_up__H0r2w {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  color: #ffffff;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_desc_block__\\+W\\+Q2 .Tournament_quest_inner_desc_block_name_down__DOVHM {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #e0e0e0;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_desc_block__\\+W\\+Q2 .Tournament_quest_inner_desc_block_chips__vG66z {
  display: flex;
  flex-direction: row;
  gap: 15px;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_desc_block__\\+W\\+Q2 .Tournament_quest_inner_desc_block_chips__vG66z .Tournament_quest_inner_desc_block_chips_up__7RQx- {
  border-radius: 8px;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
  padding: 12px;
  background-color: rgba(241, 248, 19, 0.15);
  color: #f1f813;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_desc_block__\\+W\\+Q2 .Tournament_quest_inner_desc_block_chips__vG66z .Tournament_quest_inner_desc_block_chips_down__PwUXx {
  border-radius: 8px;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
  padding: 12px;
  background-color: rgba(191, 46, 26, 0.15);
  color: #bf2e1a;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_button_btn__Wu-7u {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  background-color: #ead40c;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 16px;
  padding-top: 12px;
  padding-bottom: 12px;
  transition: all 0.2s linear;
  width: 100%;
}
.Tournament_quest_container__UvhA7 .Tournament_quest_wrapper__u1E-8 .Tournament_quest_inner__e05mD .Tournament_quest_inner_button_btn__Wu-7u:hover {
  background-color: #ffeb31;
}

.Tournament_background__c14Xi {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.Tournament_background__c14Xi .Tournament_background_inner__FqqPP {
  background-color: rgba(27, 30, 35, 0.8);
  padding-bottom: 30px;
}

.Tournament_container__w-YEN {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding-bottom: 44px;
  padding-top: 30px;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN {
  margin: 0 auto;
  width: 80%;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI {
  position: relative;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_title__VgBkd {
  font-size: 32px;
  font-weight: 700;
  color: #FAF9F8;
  margin-bottom: 16px;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_modalGame__jMOYl {
  display: flex;
  margin-bottom: 16px;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_modalGame__jMOYl .Tournament_modalGameItem__HmLVU {
  align-items: center;
  background-color: #611d14;
  border-radius: 100px;
  color: #fff;
  display: flex;
  gap: 4px;
  font-size: 16px;
  font-weight: 400;
  padding: 13px 16px;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_modalGame__jMOYl .Tournament_modalGameItemCS__j4g88 {
  background-color: #614714;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_modalGame__jMOYl .Tournament_modalGameItemLoL__WK5Xj {
  background-color: #614714;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_dates__e1xBN {
  font-size: 20px;
  font-weight: 400;
  color: #DAD6CE;
  display: flex;
  gap: 25px;
  margin-bottom: 16px;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_dates__e1xBN .Tournament_date__JBY7Q {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  margin-top: 7px;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_description__Jeyz7 {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #e0e0e0;
  line-height: 130%;
  margin-bottom: 16px;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_remove_events__zw9D\\+ {
  display: inline-flex;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_remove_events__zw9D\\+ button {
  pointer-events: none;
}
.Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_button_disabled__rkORb {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  border-radius: 8px;
  width: 336px;
  height: 46px;
  background: grey;
  cursor: pointer;
  color: rgba(224, 224, 224, 0.7);
}

.Tournament_wrapperQuests__AhWQt {
  font-size: 32px;
  font-weight: 700;
  font-style: normal;
  color: #fff;
  margin: 50px auto;
  position: relative;
  width: 80%;
  z-index: 3;
}

@media (max-width: 850px) {
  .Tournament_container__w-YEN {
    padding-top: 80px;
  }
  .Tournament_container__w-YEN .Tournament_wrapper__uV2xN {
    width: 90%;
  }
  .Tournament_container__w-YEN .Tournament_wrapper__uV2xN .Tournament_info__VlKNI .Tournament_title__VgBkd {
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
    line-height: 130%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Tournaments/Tournament/Tournament.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,cAAA;EACA,kBAAA;AADF;AAEE;EACE,oCAAA;EACA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACN;AAAM;EACE,iBAAA;EACA,WAAA;AAER;AAAM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAER;AADQ;EACE,cAAA;ECER,eAAA;EACA,gBAAA;EACA,kBAAA;ADEF;AAHQ;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AAKV;AAFM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAIR;AAHQ;EC9BN,eAAA;EACA,gBAAA;EACA,kBAAA;ED8BQ,cAAA;AAOV;AALQ;EC0GN,eAAA;EACA,gBAAA;EACA,kBAAA;ED1GQ,cAAA;AASV;AAPQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AASV;AARU;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,0CAAA;EACA,cAAA;AAUZ;AARU;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,yCAAA;EACA,cAAA;AAUZ;AANM;EACE,eAAA;ECjCN,eAAA;EACA,gBAAA;EACA,kBAAA;EDkCM,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,2BAAA;EACA,WAAA;AASR;AAPQ;EACE,yBAAA;AASV;;AAFA;EACE,sBAAA;EACA,4BAAA;EACA,2BAAA;AAKF;AAHE;EACE,uCAAA;EACA,oBAAA;AAKJ;;AADA;EACE,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,oBAAA;EACA,iBAAA;AAIF;AAFE;EACE,cAAA;EACA,UAAA;AAIJ;AAFI;EACE,kBAAA;AAIN;AADM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAGR;AAAM;EACE,aAAA;EACA,mBAAA;AAER;AAAQ;EACE,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAEV;AACQ;EACE,yBAAA;AACV;AACQ;EACE,yBAAA;AACV;AAGM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AADR;AAGQ;EClIN,eAAA;EACA,gBAAA;EACA,kBAAA;EDmIQ,cAAA;EACA,eAAA;AAAV;AAIM;ECpIJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDqIM,cAAA;EACA,iBAAA;EACA,mBAAA;AADR;AAGM;EACE,oBAAA;AADR;AAGQ;EACE,oBAAA;AADV;AAIM;EClJJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDkJM,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;AAAR;;AAOA;EC9LE,eAAA;EACA,gBAAA;EACA,kBAAA;ED+LA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AAHF;;AAMA;EACE;IACE,iBAAA;EAHF;EAIE;IACE,UAAA;EAFJ;EAKM;IC/MN,eAAA;IACA,gBAAA;IACA,kBAAA;IDgNQ,iBAAA;EAFR;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.quest_container {\n  width: 80%;\n  margin: 0 auto;\n  position: relative;\n  .quest_wrapper {\n    background-color: rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 0, 0, 0);\n    border-radius: 8px;\n    padding: 16px;\n    transition: all 0.2s linear;\n    height: auto;\n    max-width: 368px;\n    width: 100%;\n    .quest_inner {\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n      .quest_inner_img {\n        object-fit: cover;\n        width: 100%;\n      }\n      .quest_inner_name {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        .quest_inner_name_up {\n          color: #ae6fff;\n          @include subtitle3b;\n        }\n        .quest_inner_name_status {\n          border-radius: 8px;\n          font-family: \"Roboto\";\n          font-size: 16px;\n          font-weight: 500;\n          padding: 12px;\n          background-color: rgba(241, 248, 19, 0.15);\n          color: #f1f813;\n          min-width: 82px;\n          display: flex;\n          justify-content: center;\n        }\n      }\n      .quest_inner_desc_block {\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n        .quest_inner_desc_block_name_up {\n          @include subtitle1b;\n          color: #ffffff;\n        }\n        .quest_inner_desc_block_name_down {\n          @include body1;\n          color: #e0e0e0;\n        }\n        .quest_inner_desc_block_chips {\n          display: flex;\n          flex-direction: row;\n          gap: 15px;\n          .quest_inner_desc_block_chips_up {\n            border-radius: 8px;\n            font-family: \"Roboto\";\n            font-size: 16px;\n            font-weight: 500;\n            padding: 12px;\n            background-color: rgba(241, 248, 19, 0.15);\n            color: #f1f813;\n          }\n          .quest_inner_desc_block_chips_down {\n            border-radius: 8px;\n            font-family: \"Roboto\";\n            font-size: 16px;\n            font-weight: 500;\n            padding: 12px;\n            background-color: rgba(191, 46, 26, 0.15);\n            color: #bf2e1a;\n          }\n        }\n      }\n      .quest_inner_button_btn {\n        cursor: pointer;\n        @include subtitle6m;\n\n        background-color: #ead40c;\n        border-radius: 8px;\n        cursor: pointer;\n        margin-top: 16px;\n        padding-top: 12px;\n        padding-bottom: 12px;\n        transition: all 0.2s linear;\n        width: 100%;\n\n        &:hover {\n          background-color: #ffeb31;\n        }\n      }\n    }\n  }\n}\n\n.background {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n \n  .background_inner {\n    background-color: rgba(27, 30, 35, 0.8);\n    padding-bottom: 30px;\n  }\n}\n\n.container {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  padding-bottom: 44px;\n  padding-top: 30px;\n\n  .wrapper {\n    margin: 0 auto;\n    width: 80%;\n\n    .info {\n      position: relative;\n      // z-index: 1;\n\n      .title {\n        font-size: 32px;\n        font-weight: 700;\n        color: #FAF9F8;\n        margin-bottom: 16px;\n      }\n\n      .modalGame {\n        display: flex;\n        margin-bottom: 16px;\n\n        .modalGameItem {\n          align-items: center;\n          background-color: #611d14;\n          border-radius: 100px;\n          color: #fff;\n          display: flex;\n          gap: 4px;\n          font-size: 16px;\n          font-weight: 400;\n          padding: 13px 16px;\n        }\n\n        .modalGameItemCS {\n          background-color: #614714;\n        }\n        .modalGameItemLoL {\n          background-color: #614714;\n        }\n      }\n\n      .dates {\n        font-size: 20px;\n        font-weight: 400;\n        color: #DAD6CE;\n        display: flex;\n        gap: 25px;\n        margin-bottom: 16px;\n\n        .date {\n          @include subtitle4m;\n\n          color: #ffffff;\n          margin-top: 7px;\n        }\n      }\n\n      .description {\n        @include subtitle5;\n\n        color: #e0e0e0;\n        line-height: 130%;\n        margin-bottom: 16px;\n      }\n      .remove_events {\n        display: inline-flex;\n\n        button {\n          pointer-events: none;\n        }\n      }\n      .button_disabled {\n        @include subtitle5;\n        border-radius: 8px;\n        width: 336px;\n        height: 46px;\n        background: grey;\n        cursor: pointer;\n        color: rgba(224, 224, 224, 0.7);\n        \n      }\n    }\n  }\n}\n\n.wrapperQuests {\n  @include h3;\n\n  color: #fff;\n  margin: 50px auto;\n  position: relative;\n  width: 80%;\n  z-index: 3;\n}\n\n@media (max-width: 850px) {\n  .container {\n    padding-top: 80px;\n    .wrapper {\n      width: 90%;\n\n      .info {\n        .title {\n          @include h3;\n\n          line-height: 130%;\n        }\n      }\n    }\n  }\n}\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quest_container": `Tournament_quest_container__UvhA7`,
	"quest_wrapper": `Tournament_quest_wrapper__u1E-8`,
	"quest_inner": `Tournament_quest_inner__e05mD`,
	"quest_inner_img": `Tournament_quest_inner_img__6jeho`,
	"quest_inner_name": `Tournament_quest_inner_name__ziHcj`,
	"quest_inner_name_up": `Tournament_quest_inner_name_up__e5kZN`,
	"quest_inner_name_status": `Tournament_quest_inner_name_status__eb7Dl`,
	"quest_inner_desc_block": `Tournament_quest_inner_desc_block__+W+Q2`,
	"quest_inner_desc_block_name_up": `Tournament_quest_inner_desc_block_name_up__H0r2w`,
	"quest_inner_desc_block_name_down": `Tournament_quest_inner_desc_block_name_down__DOVHM`,
	"quest_inner_desc_block_chips": `Tournament_quest_inner_desc_block_chips__vG66z`,
	"quest_inner_desc_block_chips_up": `Tournament_quest_inner_desc_block_chips_up__7RQx-`,
	"quest_inner_desc_block_chips_down": `Tournament_quest_inner_desc_block_chips_down__PwUXx`,
	"quest_inner_button_btn": `Tournament_quest_inner_button_btn__Wu-7u`,
	"background": `Tournament_background__c14Xi`,
	"background_inner": `Tournament_background_inner__FqqPP`,
	"container": `Tournament_container__w-YEN`,
	"wrapper": `Tournament_wrapper__uV2xN`,
	"info": `Tournament_info__VlKNI`,
	"title": `Tournament_title__VgBkd`,
	"modalGame": `Tournament_modalGame__jMOYl`,
	"modalGameItem": `Tournament_modalGameItem__HmLVU`,
	"modalGameItemCS": `Tournament_modalGameItemCS__j4g88`,
	"modalGameItemLoL": `Tournament_modalGameItemLoL__WK5Xj`,
	"dates": `Tournament_dates__e1xBN`,
	"date": `Tournament_date__JBY7Q`,
	"description": `Tournament_description__Jeyz7`,
	"remove_events": `Tournament_remove_events__zw9D+`,
	"button_disabled": `Tournament_button_disabled__rkORb`,
	"wrapperQuests": `Tournament_wrapperQuests__AhWQt`
};
export default ___CSS_LOADER_EXPORT___;
